// libraries
import React, { useState, useEffect } from 'react'
import 'dayjs/locale/nb'
import clsx from 'clsx'
// components
import Section from '/react4xp/components/Section'
import Link from '/react4xp/components/Link'
import IdeaCard from '/react4xp/components/IdeaCard'
import MasonryGrid from '/react4xp/components/MasonryGrid'

// svg
import { UxArrowDown, UxArrowRight } from '/react4xp/components/Svg/Ux/Arrow'

export default function listQIdeasComponent({
    title,
    qIdeasLiked,
    endpoint,
    startValues,
    overviewCTA,
    strings,
    bgColor,
    isWhite,
    services,
    isLogged,
    type
}) {
	const [qIdeas, setQIdeas] = useState<any[]>([])
    const [page, setPage] = useState(startValues?.page || 1)
    const [hasNextPage, setHasNextPage] = useState(false)
    const [loadMore, setLoadMore] = useState(false)
    const [total, setTotal] = useState(0)

    useEffect(() => {
        handleFetchQIdeas()
	}, [page])

    const handleFetchQIdeas = async ()=> {
        
        if(!endpoint) return;
        
        const origin = window.location.origin;
        const url = new URL(`${origin}${endpoint}`);
        const queryParams = new URLSearchParams();

        queryParams.append('type', type || 'ideas')
        if (page) queryParams.append('page', String(page));
        if (startValues?.pageSize) queryParams.append('pageSize', startValues?.pageSize);
        if (startValues?.status) queryParams.append('status', startValues?.status);
        if (startValues?.packaging) queryParams.append('packaging', startValues?.packaging);
        if (startValues?.taste) queryParams.append('taste', startValues?.taste);
        if (startValues?.category) queryParams.append('category', startValues?.category);
        if (startValues?.sort) queryParams.append('sort', startValues?.sort);
    
        url.search = queryParams.toString();

        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }
            const data = await response.json();
            
            if(loadMore){
                setQIdeas([...qIdeas, ...data.hits]);
                setLoadMore(false)
            }else{
                setQIdeas(data.hits);
            }

            setHasNextPage(data.hasNextPage);
            setTotal(data.total)

        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
    }
    
	const handleLoadMoreQIdeas = () => {
        if(hasNextPage){
            setLoadMore(true)
            setPage(page + 1)
        }
    }

	return (
        <div className='page-q-idea page-q-idea--home'>
            <Section
                bgColor={bgColor || 'blue'}
                paddingTop='small'
                className='all-ideas'
            >
                <div className='container'>

                    <div className='idea-category idea-category--approved'>

                        <h2 className={clsx('h2 idea-category__title', isWhite && 'white')}>
                            {title}
                        </h2>

                        <div className='idea-category__details'>

                            <div className='total'>
                                <p className={clsx(isWhite && 'white')}>
                                    {qIdeas.length} av {total} idéer
                                </p>
                            </div>

                            <Link
                                href={overviewCTA?.href}
                                text={overviewCTA?.text}
                                iconPosition='right'
                                icon={<UxArrowRight />}
                                isWhite={isWhite}
                            />

                        </div>

                        <div className='idea-category__grid'>

                            <MasonryGrid
                                items={qIdeas || []}
                                columnGutter={20}
                                maxColumnCount={3}
                                breakpointCols={{
                                    default: 3,
                                    1200: 2,
                                    676: 1
                                }}
                                columnWidth={275}
                                overscanBy={99}
                                render={({ data }) => 
                                    <IdeaCard
                                        image={data.image?.link}
                                        alt={data.image?.alt}
                                        status={data.statusData?.status}
                                        statusText={data.statusData?.label}
                                        title={data.title}
                                        extraField={data.extraField}
                                        desc={data.description}
                                        likes={data.likes}
                                        isLiked={qIdeasLiked.includes(data.id)}
                                        comments={data.comments}
                                        href={data.url?.href}
                                        isInteractive={true}
                                        services={{
                                            likeContent: services?.likeContent
                                        }}
                                        isLogged={isLogged}
                                        contentId={data.id}
                                    />
                                }
                            />

                            {hasNextPage && (
                                <div className='load-more'>
                                    <Link
                                        text={strings?.loadMore}
                                        onClick={handleLoadMoreQIdeas}
                                        iconPosition='right'
                                        icon={<UxArrowDown />}
                                        isWhite={isWhite}
                                    />
                                </div>
                            )}

                        </div>

                    </div>
                    
                </div>
            </Section>
        </div>
	)
}
